export default __webpack_public_path__ + "static/coach-min-e017e5b94e9b6381b2bd90158ebba626.png";